"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[423],{

/***/ 80384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_switch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45810);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66261);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var _elements_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81474);
/* harmony import */ var _public_assets_icons_boat_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93238);
/* harmony import */ var _public_assets_icons_tips_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31119);
/* harmony import */ var _headline__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17587);
/* harmony import */ var _helper_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1075);










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var defaultImagePath = '/assets/images/hero';
var defaultImage = "".concat(defaultImagePath, "/2x.jpg");
function Hero(param) {
    var _pretitle = param.pretitle, pretitle = _pretitle === void 0 ? '' : _pretitle, title = param.title, teaser = param.teaser, href = param.href, label = param.label, _checked = param.checked, checked = _checked === void 0 ? false : _checked, _setChecked = param.setChecked, setChecked = _setChecked === void 0 ? function() {} : _setChecked, _photoUrl = param.photoUrl, photoUrl = _photoUrl === void 0 ? defaultImage : _photoUrl, _switchSearchLabel = param.switchSearchLabel, switchSearchLabel = _switchSearchLabel === void 0 ? 'Boote suchen & finden' : _switchSearchLabel, _switchLabel = param.switchLabel, switchLabel = _switchLabel === void 0 ? 'Revierinformationen' : _switchLabel, _toggle = param.toggle, toggle = _toggle === void 0 ? true : _toggle, _regionalStatus = param.regionalStatus, regionalStatus = _regionalStatus === void 0 ? '' : _regionalStatus, _after = param.after, after = _after === void 0 ? '' : _after, _before = param.before, before = _before === void 0 ? '' : _before;
    var setCheckedFunc = function(v) {
        setChecked(v);
        if (v) {
            setTimeout(function() {
                react_scroll__WEBPACK_IMPORTED_MODULE_3__/* .scroller.scrollTo */ .OK.scrollTo('breadcrumbs', {
                    duration: 1500,
                    delay: 100,
                    smooth: true
                });
            }, 600);
        }
    };
    var ref = _slicedToArray(photoUrl && photoUrl !== defaultImage ? [
        (0,_helper_image__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(photoUrl.publicUrl, {
            w: 750
        }),
        (0,_helper_image__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(photoUrl.publicUrl, {
            w: 1500
        })
    ] : [
        "".concat(defaultImagePath, "/1x.jpg"),
        "".concat(defaultImagePath, "/2x.jpg")
    ], 2), image1x = ref[0], image2x = ref[1];
    // noinspection CssUnusedSymbol
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "cfa146fce3ae7b0c",
                [
                    image2x,
                    image1x,
                    image2x
                ]
            ]
        ]) + " " + "bg-gray-200 mt-header relative grid grid-cols-1 md:grid-cols-2",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "cfa146fce3ae7b0c",
                dynamic: [
                    image2x,
                    image1x,
                    image2x
                ],
                /*#__PURE__*/ children: "#hero-background-image.__jsx-style-dynamic-selector{background-image:url(".concat(image2x, ");\nbackground-image:-webkit-image-set(url(").concat(image1x, ") 1x, url(").concat(image2x, ") 2x);\nbackground-image:image-set(url(").concat(image1x, ") 1x, url(").concat(image2x, ") 2x)}")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "hero-background-image",
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "cfa146fce3ae7b0c",
                        [
                            image2x,
                            image1x,
                            image2x
                        ]
                    ]
                ]) + " " + "relative bg-center bg-cover bg-no-repeat h-32 md:h-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    viewBox: "0 0 100 35",
                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                        [
                            "cfa146fce3ae7b0c",
                            [
                                image2x,
                                image1x,
                                image2x
                            ]
                        ]
                    ]) + " " + "w-full absolute bottom-0 md:hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M00 30 Q 50 40 100 30 L100 60 L0 60 Z",
                        fill: "#F3F2F2",
                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "cfa146fce3ae7b0c",
                                [
                                    image2x,
                                    image1x,
                                    image2x
                                ]
                            ]
                        ]) + " " + "path fill-gray-200"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "cfa146fce3ae7b0c",
                        [
                            image2x,
                            image1x,
                            image2x
                        ]
                    ]
                ]) + " " + "py-2 pb-12 md:py-8 px-6 md:px-10 w-full max-w-2xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "cfa146fce3ae7b0c",
                                [
                                    image2x,
                                    image1x,
                                    image2x
                                ]
                            ]
                        ]) + " " + "font-bold lg:text-sm text-xs mb-3",
                        children: pretitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headline__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        tag: 1,
                        after: after,
                        before: before,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                [
                                    "cfa146fce3ae7b0c",
                                    [
                                        image2x,
                                        image1x,
                                        image2x
                                    ]
                                ]
                            ]),
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: teaser
                        },
                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "cfa146fce3ae7b0c",
                                [
                                    image2x,
                                    image1x,
                                    image2x
                                ]
                            ]
                        ]) + " " + "lg:text-base text-sm max-w-lg lg:pr-10 pb-8"
                    }),
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: href,
                        children: label
                    }),
                    toggle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "cfa146fce3ae7b0c",
                                [
                                    image2x,
                                    image1x,
                                    image2x
                                ]
                            ]
                        ]) + " " + "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                    [
                                        "cfa146fce3ae7b0c",
                                        [
                                            image2x,
                                            image1x,
                                            image2x
                                        ]
                                    ]
                                ]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_switch__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        checked: checked,
                                        onChange: setCheckedFunc,
                                        handleDiameter: 50,
                                        offColor: "#f8f8f8",
                                        onColor: "#292984",
                                        offHandleColor: "#FBB900",
                                        onHandleColor: "#FBB900",
                                        height: 40,
                                        width: 100,
                                        borderRadius: 30,
                                        activeBoxShadow: "0px 0px 1px 2px #fffc35",
                                        uncheckedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                                marginRight: '-.8rem'
                                            },
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "cfa146fce3ae7b0c",
                                                    [
                                                        image2x,
                                                        image1x,
                                                        image2x
                                                    ]
                                                ]
                                            ]),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_tips_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                height: 20
                                            })
                                        }),
                                        checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                color: '#fff',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                                marginLeft: '-.8rem'
                                            },
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "cfa146fce3ae7b0c",
                                                    [
                                                        image2x,
                                                        image1x,
                                                        image2x
                                                    ]
                                                ]
                                            ]),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_boat_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                height: 20
                                            })
                                        }),
                                        uncheckedHandleIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                color: '#000',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%'
                                            },
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "cfa146fce3ae7b0c",
                                                    [
                                                        image2x,
                                                        image1x,
                                                        image2x
                                                    ]
                                                ]
                                            ]),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_boat_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                height: 20
                                            })
                                        }),
                                        checkedHandleIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%'
                                            },
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "cfa146fce3ae7b0c",
                                                    [
                                                        image2x,
                                                        image1x,
                                                        image2x
                                                    ]
                                                ]
                                            ]),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_tips_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                height: 20
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 250 44.54",
                                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                            [
                                                "cfa146fce3ae7b0c",
                                                [
                                                    image2x,
                                                    image1x,
                                                    image2x
                                                ]
                                            ]
                                        ]) + " " + "-mt-1 h-12 ml-6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                                points: "1.5 0 1.5 38.27 16.5 38.27",
                                                fill: "none",
                                                stroke: "#FBB900",
                                                strokeWidth: "3",
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "cfa146fce3ae7b0c",
                                                        [
                                                            image2x,
                                                            image1x,
                                                            image2x
                                                        ]
                                                    ]
                                                ])
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                                points: "55.0 0 55.0 12.2 70 12.2",
                                                fill: "none",
                                                stroke: "#FBB900",
                                                strokeWidth: "3",
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "cfa146fce3ae7b0c",
                                                        [
                                                            image2x,
                                                            image1x,
                                                            image2x
                                                        ]
                                                    ]
                                                ])
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                                                transform: "translate(80 17.22)",
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "cfa146fce3ae7b0c",
                                                        [
                                                            image2x,
                                                            image1x,
                                                            image2x
                                                        ]
                                                    ]
                                                ]) + " " + "transition-all ".concat(checked ? 'font-semibold fill-primary' : 'fill-black'),
                                                children: switchLabel
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                                                transform: "translate(25.37 43.54)",
                                                dangerouslySetInnerHTML: {
                                                    __html: switchSearchLabel
                                                },
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "cfa146fce3ae7b0c",
                                                        [
                                                            image2x,
                                                            image1x,
                                                            image2x
                                                        ]
                                                    ]
                                                ]) + " " + "transition-all ".concat(!checked ? 'font-semibold fill-primary' : 'fill-black')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            regionalStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                    [
                                        "cfa146fce3ae7b0c",
                                        [
                                            image2x,
                                            image1x,
                                            image2x
                                        ]
                                    ]
                                ]) + " " + "z-50 ml-auto hover:scale-125 transition",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                    src: "/assets/icons/partner/".concat(regionalStatus, ".svg"),
                                    alt: "".concat(regionalStatus, " Partner"),
                                    width: 110,
                                    height: 110
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                viewBox: "0 0 100 35",
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "cfa146fce3ae7b0c",
                        [
                            image2x,
                            image1x,
                            image2x
                        ]
                    ]
                ]) + " " + "w-full absolute bottom-0 pointer-events-none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M00 30 Q 50 40 100 30 L100 60 L0 60 Z",
                    fill: "#fff",
                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                        [
                            "cfa146fce3ae7b0c",
                            [
                                image2x,
                                image1x,
                                image2x
                            ]
                        ]
                    ]) + " " + "path sc-correos-cdk-simple-header"
                })
            })
        ]
    }));
};


/***/ }),

/***/ 88304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68121);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40169);


function Pagination(param) {
    var _perPage = param.perPage, perPage = _perPage === void 0 ? 15 : _perPage, total = param.total, paginate = param.paginate, current = param.current;
    var pageNumbers = [];
    // eslint-disable-next-line no-plusplus
    for(var i = 1; i <= Math.ceil(total / perPage); i++){
        pageNumbers.push(i);
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-row items-center justify-between mx-auto w-full lg:max-w-xl mt-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "border text-xl rounded-full w-12 h-12 lg:w-16 lg:h-16 hover:opacity-75 active:shadow-none ".concat(current <= 1 ? 'border-gray-200 text-gray-200 pointer-events-none' : 'border-primary-500 text-primary-500 cursor-pointer'),
                disabled: current <= 1,
                onClick: function() {
                    return paginate(current - 1);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "mx-auto h-1/2"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "text-xl text-zz-blue-500",
                children: [
                    "Seite",
                    ' ',
                    current,
                    ' ',
                    "von",
                    ' ',
                    Math.ceil(total / perPage)
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                disabled: current >= Math.ceil(total / perPage),
                onClick: function() {
                    return paginate(current + 1);
                },
                className: "border text-xl rounded-full w-12 h-12 lg:w-16 lg:h-16 hover:opacity-75 active:shadow-none ".concat(current >= Math.ceil(total / perPage) ? 'border-gray-200 text-gray-200 pointer-events-none' : 'border-primary-500 text-primary-500 cursor-pointer'),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "mx-auto h-1/2"
                })
            })
        ]
    }));
};


/***/ })

}]);